import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Table,
  Spinner,
  // Tabs,
  // Tab,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { TUTOR_DASHBOARD_API } from "../../../api/api";

import { FaSearch } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { AiOutlineRise } from "react-icons/ai";

// Replace these imports with your actual icon images
// import bookIcon from "../../../assets/tutor-dsh-icon1.png";
// import studentIcon from "../../../assets/tutor-dsh-icon2.png";
// import assignmentIcon from "../../../assets/tutor-dsh-icon3.png";
// import starIcon from "../../../assets/tutor-dsh-icon4.png";
// import rupeeIcon from "../../../assets/tutor-dsh-icon5.png";

// import addIcon from "../../../assets/tutor-dsh-btn-1.png";
// import doubtsIcon from "../../../assets/tutor-dsh-btn-2.png";
// import assignmentsIcon from "../../../assets/tutor-dsh-btn-3.png";

// latestIcons
import totalCourses from "../../../assets/icons/student/course.svg";
// import activeStudents from "../../../assets/icons/tutor/active-students.svg";
import enrolledStudents from "../../../assets/icons/admin/enrolled-students.svg";
import assignmentsPending from "../../../assets/icons/student/assignment.svg";
import averageRating from "../../../assets/icons/tutor/average-rating.svg";

import addCourse from "../../../assets/icons/tutor/add-course.svg";
import viewDoubts from "../../../assets/icons/tutor/view-doubts.svg";

import Nofound from "../../../assets/not-found.png";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./TutorDashboard.css";

const buttons = [
  {
    label: "Add New Course",
    icon: addCourse,
    path: "/header/tutor/my-courses",
  },
  {
    label: "View Student Doubts",
    icon: viewDoubts,
    path: "/header/tutor/student-doubts",
  },
  {
    label: "Evaluate Assignments",
    icon: assignmentsPending,
    path: "/header/tutor/assignments",
  },
];

const TutorDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [tutorName, setTutorName] = useState("");
  const [recentSubmissions, setRecentSubmissions] = useState([]);
  const [tutorDashStats, setTutorDashStats] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  //loading
  const [loadingTutorDash, setloadingTutorDash] = useState(true);
  // const [key, setKey] = useState("mycourses");

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setloadingTutorDash(false);
      navigate("/signin");

      return;
    }

    const fetchTutorDashboard = async () => {
      try {
        const response = await axios.post(
          TUTOR_DASHBOARD_API.TUTOR_DASHBOARDS,
          { tutor_id: userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          setTutorName(data.tutor_name || "");
          setTutorDashStats(data.stats || {});
          setRecentSubmissions(data.recent_assignments || []);
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error tutor dashboard:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setloadingTutorDash(false);
      }
    };

    fetchTutorDashboard();
  }, [navigate]);

  const filteredSubmissions = recentSubmissions.filter(
    (item) =>
      (item.student || "")
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase()) ||
      (item.course_title || "")
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase()),
  );

  if (loadingTutorDash) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <section className="tutor-home-section">
      <Container className="p-0">
        <Row className="tutor-home-header-row align-items-center justify-content-between">
          <Col sm={12} className="tutor-home-title-col">
            <h3 className="tutor-home-title">
              Welcome to skilledition, {tutorName}{" "}
              <span className="wave">👋</span>
            </h3>
          </Col>
        </Row>

        <div className="tutor-home-banner">
          <h5 className="tutor-home-banner-heading">
            Effortlessly Create and Manage Courses That Reflect Your Teaching
            Goals
          </h5>
          <p className="tutor-home-banner-text">
            Design and publish engaging learning experiences. SkillEdition helps
            you share your expertise in your preferred language
          </p>

          <Row className="tutor-home-stats-row">
            <Col lg={3} md={4} sm={6} xs={12}>
              <div className="tutor-home-card-header">
                <h6>Total Courses</h6>
                <img
                  src={totalCourses}
                  alt="Total Courses"
                  className="tutor-home-card-icon"
                />

                <h3>{Number(tutorDashStats.total_courses) || "-"}</h3>
                <span className="tutor-home-subtext ">All Active</span>
              </div>
            </Col>

            <Col lg={3} md={4} sm={6} xs={12}>
              <div className="tutor-home-card-header">
                <h6>Enrolled Students</h6>
                <img
                  src={enrolledStudents}
                  alt="Active Students"
                  className="tutor-home-card-icon"
                />

                <h3>{Number(tutorDashStats.active_students) || "-"}</h3>
                <span className="tutor-home-success">
                  <AiOutlineRise /> +23 this week
                </span>
              </div>
            </Col>

            <Col lg={3} md={4} sm={6} xs={12}>
              <div className="tutor-home-card-header">
                <h6>Pending Grading Assignments</h6>
                <img
                  src={assignmentsPending}
                  alt="Assignments Pending"
                  className="tutor-home-card-icon"
                />

                <h3>{Number(tutorDashStats.assignments_pending) || "-"}</h3>
                <span className="tutor-home-warning">Requires attention</span>
              </div>
            </Col>

            <Col lg={3} md={4} sm={6} xs={12}>
              <div className="tutor-home-card-header">
                <h6>Average Rating</h6>
                <img
                  src={averageRating}
                  alt="Average Rating"
                  className="tutor-home-card-icon"
                />

                <h3>{Number(tutorDashStats.average_rating) || "-"}</h3>
                <span className="tutor-home-success">★ Excellent rating</span>
              </div>
            </Col>

            {/* <Col lg={2} md={4} sm={6} xs={12}>
              <div className="tutor-home-card-header">
                <h6>Monthly Earnings</h6>
                <img
                  src={rupeeIcon}
                  alt="Rupee Icon"
                  className="tutor-home-card-icon"
                />

                <h3>₹25,000</h3>
                <span className="tutor-home-success">
                  <AiOutlineRise /> +12% from last month
                </span>
              </div>
            </Col> */}
          </Row>
        </div>

        <Row className="tutor-home-btn-row">
          {buttons.map((btn, index) => (
            <Col key={index} className="tutor-home-btn-col">
              <Button
                className={`tutor-home-btn ${
                  location.pathname === btn.path
                    ? "tutor-home-btn-active"
                    : "tutor-home-btn-outline"
                }`}
                onClick={() => navigate(btn.path)}
              >
                {/* 🔹 Replacing Icon with Image */}
                <img
                  src={btn.icon}
                  alt={btn.label}
                  className="tutor-home-btn-img"
                />
                <span>{btn.label}</span>
              </Button>
            </Col>
          ))}
        </Row>
      </Container>

      <Container className="tutor-home-recent-container">
        {/* search */}
        <div className="tutor-home-search-wrapper">
          <Form.Control
            type="search"
            placeholder="Search by name or course"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="tutor-home-search-input"
          />
          <div className="tutor-home-search-icon">
            <FaSearch />
          </div>
        </div>

        {/* Recent Submissions */}
        <div className="tutor-home-recent-table-wrapper">
          <div className="tutor-home-recent-title-wrapper">
            <h5 className="tutor-home-recent-title">
              Recent Final Assignment Submissions
            </h5>
          </div>
          <div className="tutor-home-recent-table-scroll">
            <Table className="tutor-home-recent-table">
              <thead className="tutor-home-recent-table-header">
                <tr>
                  <th>Student</th>
                  <th>Course</th>
                  <th>Final Assignment</th>
                  <th>Submitted</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredSubmissions.length === 0 ? (
                  <tr>
                    <td colSpan={12} className="tutor-assignment-table-empty">
                      <img
                        src={Nofound}
                        alt="No Data Found"
                        className="tutor-assignment-table-empty-img"
                      />
                      <p>No Data Found</p>
                    </td>
                  </tr>
                ) : (
                  filteredSubmissions.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.student}</td>
                      <td>{item.course_title}</td>
                      <td>{item.assignment_title}</td>
                      <td>{item.submitted ? item.submitted : "-"}</td>
                      <td>
                        <span
                          className={`tutor-home-recent-status ${
                            item.status === "Graded"
                              ? "tutor-home-recent-status-grade"
                              : "tutor-home-recent-status-pending"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Tabs Section */}
        {/* <div className="tutor-home-recent-tabs-section mt-4">
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="tutor-home-recent-tabs"
          >
            <Tab eventKey="mycourses" title="My Courses">
              <Row className="tutor-home-recent-course-row mt-3">
                <Col md={12} className="tutor-home-recent-course-card">
                  <div className="tutor-home-recent-course-info">
                    <div className="tutor-home-recent-course-text">
                      <h6>Advanced React Development</h6>
                      <p>234 students enrolled • 12 modules</p>
                    </div>
                    <div className="tutor-home-recent-btns">
                      <Button variant="outline-primary" size="sm">
                        Edit
                      </Button>
                      <Button variant="primary" size="sm">
                        View Details
                      </Button>
                    </div>
                  </div>
                </Col>

                <Col md={12} className="tutor-home-recent-course-card">
                  <div className="tutor-home-recent-course-info">
                    <div className="tutor-home-recent-course-text">
                      <h6>Python for Beginners</h6>
                      <p>456 students enrolled • 8 modules</p>
                    </div>
                    <div className="tutor-home-recent-btns">
                      <Button variant="outline-primary" size="sm">
                        Edit
                      </Button>
                      <Button variant="primary" size="sm">
                        View Details
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="queries" title="Student Queries">
              <div className="tutor-home-recent-tab-content">
                <p>No student queries yet.</p>
              </div>
            </Tab>
            <Tab eventKey="announcements" title="Announcements">
              <div className="tutor-home-recent-tab-content">
                <p>No announcements available.</p>
              </div>
            </Tab>
          </Tabs>
        </div> */}
      </Container>
    </section>
  );
};

export default TutorDashboard;
